import { render, staticRenderFns } from "./PerformanceActivitiesOverview.vue?vue&type=template&id=eb523990&scoped=true&"
import script from "./PerformanceActivitiesOverview.vue?vue&type=script&lang=ts&"
export * from "./PerformanceActivitiesOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceActivitiesOverview.vue?vue&type=style&index=0&id=eb523990&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb523990",
  null
  
)

export default component.exports